import { useTracking } from '../hooks/useTracking';

export default function TrackingProvider({ children }) {
  useTracking();
  return children;
}
